import React, { useState } from "react";
import { Box } from "../../../../base/Box/Box";
import CloseIcon from "../../../../assets/icons/close-icon-white.svg";
import Markup from "../../../../base/Markup/Markup";
import { Props } from "./types";
import { closeAnnouncement, useSetInitialVisibility } from "./useSetInitialVisibility";

export const HeaderAnnouncement = (props: Props) => {
  const [visible, setVisible] = useState(false)

  useSetInitialVisibility(props, setVisible)

  return visible && <Box
    as="div"
    className="relative ff-black h-24 md:h-12 z-40 w-full flex items-center justify-center mx-auto"
  >
    <Box as="div" className="flex items-center justify-between w-full px-5 lg:px-0 max-w-standard py-1">
      <Box as="div" className="text-end flex-grow flex items-center justify-center max-w-[80%] md:max-w-full">
        <Markup content={props.content} className="[&>*]:font-foundersGrotesk [&>h3]:text-lg text-left" />
      </Box>
      <Box as="div"
        role="button"
        onClick={() => closeAnnouncement(props, setVisible)}
        className="flex items-center justify-center">
        <img
          src={CloseIcon}
          alt="close-icon"
          style={{ width: "20px" }}
          className="cursor-pointer"
        />
      </Box>
    </Box>
  </Box>;
};

